import type {ICountry} from './Types';

export const Countries: ICountry[] = [
  {code: '+7 840', name: 'Abkhazia', value: '+7'},
  {code: '+93', name: 'Afghanistan', value: '+93'},
  {code: '+355', name: 'Albania', value: '+355'},
  {code: '+213', name: 'Algeria', value: '+213'},
  {code: '+1', name: 'American Samoa', value: '+1'},
  {code: '+376', name: 'Andorra', value: '+376'},
  {code: '+244', name: 'Angola', value: '+244'},
  {code: '+1', name: 'Anguilla', value: '+1'},
  {code: '+1', name: 'Antigua and Barbuda', value: '+1'},
  {code: '+54', name: 'Argentina', value: '+54'},
  {code: '+374', name: 'Armenia', value: '+374'},
  {code: '+297', name: 'Aruba', value: '+297'},
  {code: '+247', name: 'Ascension', value: '+247'},
  {code: '+61', name: 'Australia', value: '+61'},
  {code: '+672', name: 'Australian External Territories', value: '+672'},
  {code: '+43', name: 'Austria', value: '+43'},
  {code: '+994', name: 'Azerbaijan', value: '+994'},
  {code: '+1', name: 'Bahamas', value: '+1'},
  {code: '+973', name: 'Bahrain', value: '+973'},
  {code: '+880', name: 'Bangladesh', value: '+880'},
  {code: '+1', name: 'Barbados', value: '+1'},
  {code: '+1', name: 'Barbuda', value: '+1'},
  {code: '+375', name: 'Belarus', value: '+375'},
  {code: '+32', name: 'Belgium', value: '+32'},
  {code: '+501', name: 'Belize', value: '+501'},
  {code: '+229', name: 'Benin', value: '+229'},
  {code: '+1', name: 'Bermuda', value: '+1'},
  {code: '+975', name: 'Bhutan', value: '+975'},
  {code: '+591', name: 'Bolivia', value: '+591'},
  {code: '+387', name: 'Bosnia and Herzegovina', value: '+387'},
  {code: '+267', name: 'Botswana', value: '+267'},
  {code: '+55', name: 'Brazil', value: '+55'},
  {code: '+246', name: 'British Indian Ocean Territory', value: '+246'},
  {code: '+1', name: 'British Virgin Islands', value: '+1'},
  {code: '+673', name: 'Brunei', value: '+673'},
  {code: '+359', name: 'Bulgaria', value: '+359'},
  {code: '+226', name: 'Burkina Faso', value: '+226'},
  {code: '+257', name: 'Burundi', value: '+257'},
  {code: '+855', name: 'Cambodia', value: '+855'},
  {code: '+237', name: 'Cameroon', value: '+237'},
  {code: '+1', name: 'Canada', value: '+1'},
  {code: '+238', name: 'Cape Verde', value: '+238'},
  {code: '+1', name: 'Cayman Islands', value: '+1'},
  {code: '+236', name: 'Central African Republic', value: '+236'},
  {code: '+235', name: 'Chad', value: '+235'},
  {code: '+56', name: 'Chile', value: '+56'},
  {code: '+86', name: 'China', value: '+86'},
  {code: '+61', name: 'Christmas Island', value: '+61'},
  {code: '+61', name: 'Cocos-Keeling Islands', value: '+61'},
  {code: '+57', name: 'Colombia', value: '+57'},
  {code: '+269', name: 'Comoros', value: '+269'},
  {code: '+242', name: 'Congo', value: '+242'},
  {code: '+243', name: 'Congo, Dem. Rep. of (Zaire)', value: '+243'},
  {code: '+682', name: 'Cook Islands', value: '+682'},
  {code: '+506', name: 'Costa Rica', value: '+506'},
  {code: '+385', name: 'Croatia', value: '+385'},
  {code: '+53', name: 'Cuba', value: '+53'},
  {code: '+599', name: 'Curacao', value: '+599'},
  {code: '+537', name: 'Cyprus', value: '+537'},
  {code: '+420', name: 'Czech Republic', value: '+420'},
  {code: '+45', name: 'Denmark', value: '+45'},
  {code: '+246', name: 'Diego Garcia', value: '+246'},
  {code: '+253', name: 'Djibouti', value: '+253'},
  {code: '+1', name: 'Dominica', value: '+1'},
  {code: '+1', name: 'Dominican Republic', value: '+1'},
  {code: '+670', name: 'East Timor', value: '+670'},
  {code: '+56', name: 'Easter Island', value: '+56'},
  {code: '+593', name: 'Ecuador', value: '+593'},
  {code: '+20', name: 'Egypt', value: '+20'},
  {code: '+503', name: 'El Salvador', value: '+503'},
  {code: '+240', name: 'Equatorial Guinea', value: '+240'},
  {code: '+291', name: 'Eritrea', value: '+291'},
  {code: '+372', name: 'Estonia', value: '+372'},
  {code: '+251', name: 'Ethiopia', value: '+251'},
  {code: '+500', name: 'Falkland Islands', value: '+500'},
  {code: '+298', name: 'Faroe Islands', value: '+298'},
  {code: '+679', name: 'Fiji', value: '+679'},
  {code: '+358', name: 'Finland', value: '+358'},
  {code: '+33', name: 'France', value: '+33'},
  {code: '+596', name: 'Martinique', value: '+596'},
  {code: '+594', name: 'French Guiana', value: '+594'},
  {code: '+689', name: 'French Polynesia', value: '+689'},
  {code: '+241', name: 'Gabon', value: '+241'},
  {code: '+220', name: 'Gambia', value: '+220'},
  {code: '+995', name: 'Georgia', value: '+995'},
  {code: '+49', name: 'Germany', value: '+49'},
  {code: '+233', name: 'Ghana', value: '+233'},
  {code: '+350', name: 'Gibraltar', value: '+350'},
  {code: '+30', name: 'Greece', value: '+30'},
  {code: '+299', name: 'Greenland', value: '+299'},
  {code: '+1', name: 'Grenada', value: '+1'},
  {code: '+590', name: 'Guadeloupe', value: '+590'},
  {code: '+1', name: 'Guam', value: '+1'},
  {code: '+502', name: 'Guatemala', value: '+502'},
  {code: '+224', name: 'Guinea', value: '+224'},
  {code: '+245', name: 'Guinea-Bissau', value: '+245'},
  {code: '+595', name: 'Guyana', value: '+595'},
  {code: '+509', name: 'Haiti', value: '+509'},
  {code: '+504', name: 'Honduras', value: '+504'},
  {code: '+852', name: 'Hong Kong SAR China', value: '+852'},
  {code: '+36', name: 'Hungary', value: '+36'},
  {code: '+354', name: 'Iceland', value: '+354'},
  {code: '+91', name: 'India', value: '+91'},
  {code: '+62', name: 'Indonesia', value: '+62'},
  {code: '+98', name: 'Iran', value: '+98'},
  {code: '+964', name: 'Iraq', value: '+964'},
  {code: '+353', name: 'Ireland', value: '+353'},
  {code: '+972', name: 'Israel', value: '+972'},
  {code: '+39', name: 'Italy', value: '+39'},
  {code: '+225', name: 'Ivory Coast', value: '+225'},
  {code: '+1', name: 'Jamaica', value: '+1'},
  {code: '+81', name: 'Japan', value: '+81'},
  {code: '+962', name: 'Jordan', value: '+962'},
  {code: '+77', name: 'Kazakhstan', value: '+7'},
  {code: '+254', name: 'Kenya', value: '+254'},
  {code: '+686', name: 'Kiribati', value: '+686'},
  {code: '+965', name: 'Kuwait', value: '+965'},
  {code: '+996', name: 'Kyrgyzstan', value: '+996'},
  {code: '+856', name: 'Laos', value: '+856'},
  {code: '+371', name: 'Latvia', value: '+371'},
  {code: '+961', name: 'Lebanon', value: '+961'},
  {code: '+266', name: 'Lesotho', value: '+266'},
  {code: '+231', name: 'Liberia', value: '+231'},
  {code: '+218', name: 'Libya', value: '+218'},
  {code: '+423', name: 'Liechtenstein', value: '+423'},
  {code: '+370', name: 'Lithuania', value: '+370'},
  {code: '+352', name: 'Luxembourg', value: '+352'},
  {code: '+853', name: 'Macau SAR China', value: '+853'},
  {code: '+389', name: 'Macedonia', value: '+389'},
  {code: '+261', name: 'Madagascar', value: '+261'},
  {code: '+265', name: 'Malawi', value: '+265'},
  {code: '+60', name: 'Malaysia', value: '+60'},
  {code: '+960', name: 'Maldives', value: '+960'},
  {code: '+223', name: 'Mali', value: '+223'},
  {code: '+356', name: 'Malta', value: '+356'},
  {code: '+692', name: 'Marshall Islands', value: '+692'},
  {code: '+596', name: 'Martinique', value: '+596'},
  {code: '+222', name: 'Mauritania', value: '+222'},
  {code: '+230', name: 'Mauritius', value: '+230'},
  {code: '+262', name: 'Mayotte or Réunion', value: '+262'},
  {code: '+52', name: 'Mexico', value: '+52'},
  {code: '+691', name: 'Micronesia', value: '+691'},
  {code: '+1', name: 'Midway Island', value: '+1'},
  {code: '+373', name: 'Moldova', value: '+373'},
  {code: '+377', name: 'Monaco', value: '+377'},
  {code: '+976', name: 'Mongolia', value: '+976'},
  {code: '+382', name: 'Montenegro', value: '+382'},
  {code: '+1', name: 'Montserrat', value: '+1'},
  {code: '+212', name: 'Morocco', value: '+212'},
  {code: '+95', name: 'Myanmar', value: '+95'},
  {code: '+264', name: 'Namibia', value: '+264'},
  {code: '+674', name: 'Nauru', value: '+674'},
  {code: '+977', name: 'Nepal', value: '+977'},
  {code: '+31', name: 'Netherlands', value: '+31'},
  {code: '+599', name: 'Netherlands Antilles', value: '+599'},
  {code: '+1', name: 'Nevis', value: '+1'},
  {code: '+687', name: 'New Caledonia', value: '+687'},
  {code: '+64', name: 'New Zealand', value: '+64'},
  {code: '+505', name: 'Nicaragua', value: '+505'},
  {code: '+227', name: 'Niger', value: '+227'},
  {code: '+234', name: 'Nigeria', value: '+234'},
  {code: '+683', name: 'Niue', value: '+683'},
  {code: '+672', name: 'Norfolk Island', value: '+672'},
  {code: '+850', name: 'North Korea', value: '+850'},
  {code: '+1', name: 'Northern Mariana Islands', value: '+1'},
  {code: '+47', name: 'Norway', value: '+47'},
  {code: '+968', name: 'Oman', value: '+968'},
  {code: '+92', name: 'Pakistan', value: '+92'},
  {code: '+680', name: 'Palau', value: '+680'},
  {code: '+970', name: 'Palestinian Territory', value: '+970'},
  {code: '+507', name: 'Panama', value: '+507'},
  {code: '+675', name: 'Papua New Guinea', value: '+675'},
  {code: '+595', name: 'Paraguay', value: '+595'},
  {code: '+51', name: 'Peru', value: '+51'},
  {code: '+63', name: 'Philippines', value: '+63'},
  {code: '+48', name: 'Poland', value: '+48'},
  {code: '+351', name: 'Portugal', value: '+351'},
  {code: '+1', name: 'Puerto Rico', value: '+1'},
  {code: '+974', name: 'Qatar', value: '+974'},
  {code: '+40', name: 'Romania', value: '+40'},
  {code: '+7', name: 'Russia', value: '+7'},
  {code: '+250', name: 'Rwanda', value: '+250'},
  {code: '508', name: 'Saint Pierre and Miquelon', value: '508'},
  {code: '+685', name: 'Samoa', value: '+685'},
  {code: '+378', name: 'San Marino', value: '+378'},
  {code: '+966', name: 'Saudi Arabia', value: '+966'},
  {code: '+221', name: 'Senegal', value: '+221'},
  {code: '+381', name: 'Serbia', value: '+381'},
  {code: '+248', name: 'Seychelles', value: '+248'},
  {code: '+232', name: 'Sierra Leone', value: '+232'},
  {code: '+65', name: 'Singapore', value: '+65'},
  {code: '+421', name: 'Slovakia', value: '+421'},
  {code: '+386', name: 'Slovenia', value: '+386'},
  {code: '+677', name: 'Solomon Islands', value: '+677'},
  {code: '+27', name: 'South Africa', value: '+27'},
  {code: '+500', name: 'South Georgia and the South Sandwich Islands', value: '+500'},
  {code: '+82', name: 'South Korea', value: '+82'},
  {code: '+34', name: 'Spain', value: '+34'},
  {code: '+94', name: 'Sri Lanka', value: '+94'},
  {code: '+249', name: 'Sudan', value: '+249'},
  {code: '+597', name: 'Suriname', value: '+597'},
  {code: '+268', name: 'Swaziland', value: '+268'},
  {code: '+46', name: 'Sweden', value: '+46'},
  {code: '+41', name: 'Switzerland', value: '+41'},
  {code: '+963', name: 'Syria', value: '+963'},
  {code: '+886', name: 'Taiwan', value: '+886'},
  {code: '+992', name: 'Tajikistan', value: '+992'},
  {code: '+255', name: 'Tanzania', value: '+255'},
  {code: '+66', name: 'Thailand', value: '+66'},
  {code: '+670', name: 'Timor Leste', value: '+670'},
  {code: '+228', name: 'Togo', value: '+228'},
  {code: '+690', name: 'Tokelau', value: '+690'},
  {code: '+676', name: 'Tonga', value: '+676'},
  {code: '+1', name: 'Trinidad and Tobago', value: '+1'},
  {code: '+216', name: 'Tunisia', value: '+216'},
  {code: '+90', name: 'Turkey', value: '+90'},
  {code: '+993', name: 'Turkmenistan', value: '+993'},
  {code: '+1', name: 'Turks and Caicos Islands', value: '+1'},
  {code: '+688', name: 'Tuvalu', value: '+688'},
  {code: '+1', name: 'U.S. Virgin Islands', value: '+1'},
  {code: '+256', name: 'Uganda', value: '+256'},
  {code: '+380', name: 'Ukraine', value: '+380'},
  {code: '+971', name: 'United Arab Emirates', value: '+971'},
  {code: '+44', name: 'United Kingdom', value: '+44'},
  {code: '+1', name: 'United States', value: '+1'},
  {code: '+598', name: 'Uruguay', value: '+598'},
  {code: '+998', name: 'Uzbekistan', value: '+998'},
  {code: '+678', name: 'Vanuatu', value: '+678'},
  {code: '+58', name: 'Venezuela', value: '+58'},
  {code: '+84', name: 'Vietnam', value: '+84'},
  {code: '+1', name: 'Wake Island', value: '+1'},
  {code: '+681', name: 'Wallis and Futuna', value: '+681'},
  {code: '+967', name: 'Yemen', value: '+967'},
  {code: '+260', name: 'Zambia', value: '+260'},
  {code: '+255', name: 'Zanzibar', value: '+255'},
  {code: '+263', name: 'Zimbabwe', value: '+263'},
];

export function getCountryByCode(code: string): ICountry | null {
  const found = Countries.find((country) => country.code === code);
  if (found) return found;

  if (isFrenchGuiana(code)) {
    return {code: '+594', name: 'French Guiana', value: '+594'};
  } else if (isGuadeloupe(code)) {
    return {code: '+590', name: 'Guadeloupe', value: '+590'};
  } else if (isMartinique(code)) {
    return {code: '+596', name: 'Martinique', value: '+596'};
  } else if (isMayotte(code)) {
    return {code: '+262', name: 'Mayotte or Réunion', value: '+262'};
  }

  return null;
}

export function isFrenchGuiana(code: string) {
  return '+594' === code.substring(0, 4);
}

export function isGuadeloupe(code: string) {
  return '+590' === code.substring(0, 4);
}

export function isMartinique(code: string) {
  return '+596' === code.substring(0, 4);
}

export function isMayotte(code: string) {
  return '+262' === code.substring(0, 4);
}

export function getPlusOneCountry(code: string) {
  let info: ICountry | null = null;
  switch (code.substring(0, 5)) {
    case '+1684':
      info = {code: '+1', name: 'American Samoa', value: '+1'};
      break;
    case '+1264':
      info = {code: '+1', name: 'Anguilla', value: '+1'};
      break;
    case '+1268':
      info = {code: '+1', name: 'Antigua and Barbuda', value: '+1'};
      break;
    case '+1242':
      info = {code: '+1', name: 'Bahamas', value: '+1'};
      break;
    case '+1246':
      info = {code: '+1', name: 'Barbados', value: '+1'};
      break;
    case '+1441':
      info = {code: '+1', name: 'Bermuda', value: '+1'};
      break;
    case '+1284':
      info = {code: '+1', name: 'British Virgin Islands', value: '+1'};
      break;
    case '+1':
      info = {code: '+1', name: '', value: '+1'};
      break;
    default:
      break;
  }
  return info;
}

export function isCanada(code: string) {
  const canadianAreaCodes = [
    '403',
    '587',
    '780',
    '825',
    '604',
    '250',
    '778',
    '236',
    '204',
    '431',
    '506',
    '709',
    '867',
    '782',
    '902',
    '867',
    '548',
    '705',
    '365',
    '613',
    '807',
    '226',
    '289',
    '437',
    '519',
    '647',
    '905',
    '249',
    '343',
    '416',
    '902',
    '782',
    '450',
    '418',
    '579',
    '873',
    '367',
    '514',
    '581',
    '819',
    '438',
    '639',
    '306',
    '867',
  ];
  const areaCode = code.substring(0, 5);
  return canadianAreaCodes.findIndex((x) => '+1' + x === areaCode) > -1;
}

export function isAmericanSamoa(code: string) {
  return code.substring(0, 5) === '+1684';
}

export function isDominicanRepublic(code: string) {
  return '+1809' === code.substring(0, 5) || '+1829' === code.substring(0, 5) || '+1849' === code.substring(0, 5);
}

export function isPuertoRico(code: string) {
  return code.substring(0, 5) === '+' || code.substring(0, 5) === '+';
}

// need to finish
export function getMatchingCountry(code: string, substrings: number) {
  const toMatch = code.substring(0, substrings);
  return Countries.filter((c) => c.code === toMatch).length;
}

// const e164Regex = new RegExp(/\+[1-9]\d{6,14}/g);

// export function simpleE164Validator(code: string) {
//   return (code !== null && code.length < 16 && code.length > 6 && e164Regex.test(code)) || code === '' || code === null;
// }
